import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function CustomerPhoto() {
  const [showDialog, setShowDialog] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setShowDialog(true);
  };

  const handleCancel = () => {
    setShowDialog(false);
    setDeleteId(null);
  };

  const handleConfirmDelete = () => {
    // Add your delete logic here using deleteId
    alert('Deleted !!!');
    setShowDialog(false);
    setDeleteId(null);
  };

  const photos = [
    { id: 1, date: 'May 21st 2024', imageUrl: 'https://vi.alongwalker.co/img/post_images/189c01e102fc3e6a9e4dd36e9297b565.jpg' },
    { id: 2, date: 'May 21st 2024', imageUrl: 'https://vi.alongwalker.co/img/post_images/189c01e102fc3e6a9e4dd36e9297b565.jpg' },
    { id: 3, date: 'May 21st 2024', imageUrl: 'https://vi.alongwalker.co/img/post_images/189c01e102fc3e6a9e4dd36e9297b565.jpg' },
    { id: 4, date: 'May 21st 2024', imageUrl: 'https://vi.alongwalker.co/img/post_images/189c01e102fc3e6a9e4dd36e9297b565.jpg' },
    { id: 5, date: 'May 21st 2024', imageUrl: 'https://vi.alongwalker.co/img/post_images/189c01e102fc3e6a9e4dd36e9297b565.jpg' }
  ];

  return (
    <div className="p-24">
        <h1 className='text-4xl font-medium text-gray-700'>List of Photos</h1>
      <div className="grid grid-cols-1 gap-8 mt-8 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3">
        {photos.map(photo => (
          <div key={photo.id} className="w-50 bg-white rounded-lg shadow-md">
            <div className="h-50 overflow-hidden rounded-t-lg">
              <img src={photo.imageUrl} alt="profile-picture" className="w-full h-full object-cover" />
            </div>
            <div className="text-center p-4">
              <p className="text-lg text-blue-gray-700 mb-2">{photo.date}</p>
            </div>
            <div className="flex justify-end p-2">
              <div className="flex items-center justify-end">
                <p className="text-lg text-red-500 cursor-pointer" onClick={() => handleDeleteClick(photo.id)}>
                  Delete
                </p>
              </div>
            </div>
          </div>
        ))}
         
      </div>

      {showDialog && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <p className="mb-4">Do you want to delete?</p>
            <div className="flex justify-end">
              <button className="bg-gray-200 px-4 py-2 rounded-md mr-2" onClick={handleCancel}>
                Cancel
              </button>
              <button className="bg-red-500 text-white px-4 py-2 rounded-md" onClick={handleConfirmDelete}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
      <Link to='/'>
    <button
      class="mt-10 text-white py-2 px-4 uppercase rounded-lg bg-5BC0F8 hover:bg-blue-500 shadow hover:shadow-lg font-medium transition transform hover:-translate-y-0.5"
    >
    
      Back
      
    </button>
    </Link>
    </div>
  );
}
